// Convert Persian/Arabic numbers to English numbers
export const persianNumToEnglish = (str: string): string => {
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return str.replace(/[۰-۹]/g, d => persianNumbers.indexOf(d).toString());
};

// Format phone number: remove non-digits, convert Persian to English, limit to 11 digits
export const formatPhoneNumber = (value: string): string => {
  if (!value) return '';

  // Remove all non-digit characters (both Persian and English)
  const cleaned = value.replace(/[^۰-۹0-9]/g, '');

  // Convert Persian to English
  const englishNumbers = persianNumToEnglish(cleaned);

  // Limit to 11 digits
  return englishNumbers.slice(0, 11);
};
